import { RouteRecordRaw } from 'vue-router';

const assetRoutes: Array<RouteRecordRaw> = [
  {
    path: 'assets',
    component: () =>
      import('@/app/assets/components/asset-index-component.vue'),
    name: 'app.assets',
  },
];

export default assetRoutes;
